import { logError, ERROR_TYPE } from "../utils/newRelicLogger";
import criteoConfig from "../../common/CriteoAdvertsForRecs/config";

const criteoSpotLightApi = async (criteoRequiredParams, isProd) => {
  const { id, price, isInStock } = criteoRequiredParams;
  const { currency, current, previous } = price;

  try {
    const { partnerId } = criteoConfig;
    const retailVisitorId =
      await window.asos.sdk.identity.customer.customerGuid();
    const countryCode = window.asos.webContext.getWebContext().browseCountry;

    if (!criteoConfig?.endPoints?.[countryCode]) return;

    const criteoPartnerId = isProd
      ? partnerId?.[countryCode]?.prod
      : partnerId?.[countryCode]?.testEnv;

    const params = new URLSearchParams({
      "criteo-partner-id": criteoPartnerId,
      "event-type": "viewItem",
      "page-id": "viewItemApiDesktop",
      "retailer-visitor-id": retailVisitorId,
      "parent-item": id,
      quantity: Number(isInStock),
      currency,
      nocall: "oa",
      "list-price": previous?.value ?? current?.value ?? 0,
      price: current?.value ?? 0,
      availability: Number(isInStock),
    });

    const response = await fetch(
      `${criteoConfig.endPoints[countryCode]}?${params}`,
    );

    if (!response.ok) {
      throw new Error("Failed to fetch Criteo spotlight data");
    }

    return await response.json();
  } catch (error) {
    logError(ERROR_TYPE.NonCriticalAppError, {
      message: error?.message ?? String(error),
      action: "CriteoSpotLightApi",
    });
    return;
  }
};

export default criteoSpotLightApi;
